import React from 'react';
import styles from './InactiveMemberView.module.css';

const InactiveMemberView = ({ member }) => {
  const subdomain = member.subdomain || 'startingstrengthgyms';
  const purchaseUrl = `https://${subdomain}.pike13.com/shop`;

  return (
    <div className={styles.InactiveMemberView}>
      <p className={styles.Message}>You don't have an active membership plan.</p>
      <a
        href={purchaseUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.PurchaseLink}
      >
        View Membership Plans
      </a>
    </div>
  );
};

export default InactiveMemberView;
